import React, { FunctionComponent, Fragment } from 'react';
import classNames from '../../../utils/classnames';

export interface ButtonProps {
    variant?: 'tertiary' | 'ghost' | 'secondary';
    isLoading?: boolean;
    extraClasses?: string;
    url?: string;
    label?: string;
    disabled?: boolean;
    onClick?: (e?: any) => void;
}

export const Button: FunctionComponent<ButtonProps> = ({
    variant = '',
    url = null,
    label,
    extraClasses,
    disabled = false,
    isLoading,
    onClick = () => {},
    ...rest
}) => {
    const classes = classNames(
        {
            'c-button': !variant,
            'c-button--tertiary': variant === 'tertiary',
            'c-button--secondary': variant === 'secondary',
            'c-button--ghost': variant === 'ghost',
            'button--disabled': disabled,
            'button--is-loading': isLoading,
        },
        extraClasses,
    );

    return (
        <Fragment>
            {!url && (
                <button className={classes} {...rest} onClick={onClick} disabled={disabled}>
                    {label && <span className="button__label">{label}</span>}
                </button>
            )}
            {url && (
                <a href={url} className={classes} {...rest} onClick={onClick}>
                    {label && <span className="button__label">{label}</span>}
                </a>
            )}
        </Fragment>
    );
};
